import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const AttachmentModule = {
  namespaced: true,

  state: {
    attachment: {},
    attachments: []
  },

  getters: {
  },

  actions: {
    async getAttachment ({ commit, state }, attachmentId) {
      commit('setLoading', true, { root: true })

      return await PaApi().get(
        '/admin/attachments/' + attachmentId
      ).then((resp) => {
        commit('storeAttachment', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getResourceAttachments ({ commit, state }, opts) {
      commit('setLoading', true, { root: true })

      return await PaApi().get(
        `/admin/${opts.resourceType}s/${opts.resourceId}/attachments/`
      ).then((resp) => {
        commit('storeAttachments', resp)
        return resp
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    storeAttachment (state, payload) {
      state.attachment = processSuccess(payload, baseOpts)
    },

    storeAttachments (state, payload) {
      state.attachments = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/AttachmentModule.js